import React from "react";
import CustomButton from "../customButtom/CustomButton";
import CommonTextField from "../commonTextField/CommonTextField";
import FlexibleTextarea from "../textArea/FlexibleTextarea";
import DateInput from "../Inputs/DateInput";
import { useSelector } from "react-redux";

function CertificationUploadForm({
  register,
  handleSubmit,
  onSubmit,
  errors,
  onClose,
  setValue,
  readOnly,
}) {
  const mentorProfile = useSelector((state) => state.mentor);
  return (
    <form onSubmit={handleSubmit(onSubmit)} className="mt-4 overflow-y-auto">
      {/* Scrollable Content */}
      <div
        className="max-h-[40vh] overflow-y-scroll mt-2"
        style={{
          scrollbarWidth: "thin", // For Firefox
          scrollbarColor: "#6b7280 #e5e7eb", // Thumb & Track colors
        }}
      >
        {/* Certification Name */}
        <CommonTextField
          name="CertificationName"
          label="Certification Name"
          register={register}
          required
          readOnly={readOnly}
          errors={errors}
          placeholder="Enter Your Certification Name"
          defaultValue={mentorProfile?.certificationName}
          setValue={setValue}
        />

        {/* Provider */}
        <CommonTextField
          name="provider"
          label="Provider"
          readOnly={readOnly}
          register={register}
          required
          errors={errors}
          placeholder="E.g., Coursera, Udemy"
          defaultValue={mentorProfile?.certificationProvider}
          setValue={setValue}
        />

        {/* Description */}
        <FlexibleTextarea
          name="description"
          placeholder="Type here..."
          label="Description"
          readOnly={readOnly}
          outerClassName="w-full col-span-2"
          errors={errors}
          register={register}
          value={mentorProfile?.certificationDescription}
          setValue={setValue}
        />

        {/* Issue Date & Expiration Date */}
        <div className="grid grid-cols-2 gap-2 mt-3">
          <DateInput
            label="Issue Date"
            name="issueDate"
            register={register}
            readOnly={readOnly}
            errors={errors}
            defaultValue={mentorProfile?.certificationIssueDate}
            setValue={setValue}
          />
          <DateInput
            label="Expiration Date (Optional)"
            name="expirationDate"
            readOnly={readOnly}
            register={register}
            errors={errors}
            defaultValue={mentorProfile?.certificationExpiryDate}
            setValue={setValue}
          />
        </div>

        {/* Certification ID */}
        <CommonTextField
          name="certificationID"
          label="Certification ID (Optional)"
          register={register}
          readOnly={readOnly}
          required
          errors={errors}
          placeholder=""
          defaultValue={mentorProfile?.certificationId}
          setValue={setValue}
        />

        {/* Certification URL */}
        <CommonTextField
          name="certificationURL"
          label="Certification URL (Optional)"
          register={register}
          readOnly={readOnly}
          required
          errors={errors}
          placeholder=""
          defaultValue={mentorProfile?.certificationUrl}
          setValue={setValue}
        />
      </div>

      {/* Submit Button */}
      <div className="flex justify-end mt-3">
        <CustomButton
          type="button"
          label="Add"
          buttonClass="bg-custom-gradient px-[20px] py-[9px] rounded-lg w-full sm:w-[138px]"
          onClick={onClose}
        />
      </div>
    </form>
  );
}

export default CertificationUploadForm;
